// src/lib/gtag.ts
//
// GA4（gtag.js）の薄いラッパー。
// 測定ID（NEXT_PUBLIC_GA_MEASUREMENT_ID）が環境変数に無い場合（ローカル開発・
// Preview環境など）は何もしないガード付き。実際のスクリプト読み込みは
// src/app/layout.tsx（next/script）で行う。ページビューの手動送信は
// src/components/analytics/GAPageviewTracker.tsx から呼ばれる。

export const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID ?? "";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

function isGaEnabled(): boolean {
  return typeof window !== "undefined" && !!GA_MEASUREMENT_ID && typeof window.gtag === "function";
}

// ページビュー送信（App Routerのクライアント側遷移用）。
//
// gtag.jsの自動ページビュー計測は初回読み込み時にしか発火しないため
// （Next.js App Routerはフルページリロードしないクライアント側ルーティング）、
// ルート変化のたびにこの関数を明示的に呼ぶ必要がある。
// 初期化側（layout.tsx）で send_page_view: false を指定し、自動送信と
// 二重計上にならないようにしている。
export function pageview(url: string): void {
  if (!isGaEnabled()) return;
  window.gtag!("event", "page_view", {
    page_path: url,
    // window.location.hrefは?以降を含むため使わない（呼び出し側で絞った url から組み立てる）
    page_location: window.location.origin + url,
    page_title: document.title,
  });
}

// 汎用カスタムイベント送信。src/hooks/useAnalyticsEvent.ts から使う。
export function event(name: string, params: Record<string, unknown> = {}): void {
  if (!isGaEnabled()) return;
  window.gtag!("event", name, params);
}
